export default "__VITE_ASSET__BkfKrBYB__"